export default "__VITE_ASSET__DJDD_Eli__"